import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import AdminTable from "common/AdminTable";
import { getRequest, deleteRequest } from "apis/ApiInstence";
import { useNavigate } from "react-router-dom";

const CommercialServiceList = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchServices = async () => {
    setLoading(true);
    try {
      const res = await getRequest(`commercial-service`);
      // Assuming res.data returns the array directly or in a data property
      // Based on my controller, it returns res.send(data) which is the array.
      if (res.data) {
        setServices(Array.isArray(res.data) ? res.data : []);
      } else {
        toast.error("Failed to fetch services");
      }
    } catch (error) {
      toast.error("Error loading services");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const handleRemove = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await deleteRequest(`commercial-service/${id}`);
          if (res.status === 200) {
            toast.success("Service deleted successfully");
            fetchServices();
          } else {
            toast.error("Delete failed");
          }
        } catch (error) {
          toast.error("Error deleting service");
        }
      }
    });
  };

  const tableHeaders = [
    { Header: "ID", accessor: "id" },
    {
      Header: "Image",
      accessor: "image",
      Cell: ({ row }) => (
        row.original.image ? (
          <img
            src={`${process.env.REACT_APP_BACKEND}commercial_services/${row.original.image}`}
            alt="service"
            width={80}
            style={{ objectFit: "cover", borderRadius: "4px" }}
          />
        ) : (
          <span>No image</span>
        )
      ),
    },
    { Header: "Name", accessor: "name" },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <>
          <button className="btn removebtn mx-1 my-1" onClick={() => handleRemove(row.original.id)}>
            Remove
          </button>
          <button className="btn editbtn mx-1 my-1" onClick={() => navigate(`/commercial-services/update/${row.original.id}`)}>
            Edit
          </button>
        </>
      ),
    },
  ];

  if (loading) return <div className="text-center mt-5">Loading services...</div>;

  return (
    <div className="container-fluid">
      <div className="d-flex align-items-center justify-content-between mb-4 mx-4">
        <div className="mainheadig mb-0">
          <h4 className="font-weight-bold">Commercial Service List</h4>
        </div>
        <button
          className="btn addbtn"
          onClick={() => navigate('/commercial-services/add')}
        >
          + Add New Service
        </button>
      </div>
      {
        services.length > 0 ? (
          <AdminTable tableHeaders={tableHeaders} tableData={services} />
        ) : (
          <div className="text-center mt-4">No services found.</div>
        )
      }
    </div >
  );
};

export default CommercialServiceList;
